export const locale2lang = (locale: string): string => {
    if (locale.includes("-")) {
        const parts = locale.split("-");
        if (parts.length === 3) {
            return parts[1];
        }
        if (parts.length === 2) {
            return parts[0];
        }
    }
    return locale;
};

export default locale2lang;
